import Toastify from 'toastify-js';

type Config = {
  sideEffects?: {
    toastOnError?: boolean;
  };
};

export function canMoveToNextStep(currentStep: number, steps: string[], config: Config): boolean {
  if (currentStep < 0 || currentStep >= steps.length) {
    showErrorToast(config?.sideEffects?.toastOnError);
    return false;
  }

  const currentStepId = steps.at(currentStep);
  if (!currentStepId) return false;

  const currentStepElement = document.getElementById(currentStepId);
  if (!currentStepElement) return false;

  const requiredInputs = Array.from(
    currentStepElement.querySelectorAll<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>(
      'input[required], select[required], textarea[required]',
    ),
  );

  for (const input of requiredInputs) {
    if (input.type === 'checkbox' || input.type === 'radio') {
      const groupName = input.name;
      const groupInputs = currentStepElement.querySelectorAll<HTMLInputElement>(`input[name="${groupName}"]`);
      const isChecked = Array.from(groupInputs).some((i) => i.checked);
      if (!isChecked) {
        showErrorToast(config?.sideEffects?.toastOnError);
        return false;
      }
    } else if (!input.value) {
      showErrorToast(config?.sideEffects?.toastOnError);
      return false;
    }
  }
  return true;
}

function showErrorToast(shouldShow?: boolean): void {
  if (!shouldShow) return;

  const sectionElement = document.querySelector<HTMLElement>('#simple-product-config');

  const toast = Toastify({
    text: sectionElement?.dataset?.['errorMessageRequired'] || 'Please fill in all required fields.',
    gravity: 'bottom',
    position: 'center',
    stopOnFocus: true,
    style: {
      'border-radius': 'var(--radius)',
      background: 'oklch(57.7% 0.245 27.325)',
      color: 'oklch(88.5% 0.062 18.334)',
    },
    duration: 3000,
  });

  toast.showToast();
}
